// JS file for Repair

import '@main';

u.$ui.disableOnSubmit('#repair-form');

const a = $('#c-request-banner').find('a');

if (a.attr('href') === '#repair-form-wrapper') {
  a.on('click', (event) => {
    event.preventDefault();
    event.stopPropagation();

    moveAndOpen();
  });
}

const url = new URL(location.href);
if (url.searchParams.get('open') === '1') {
  moveAndOpen();
}

function moveAndOpen() {
  const formWrapper = $('#repair-form-wrapper');

  formWrapper.slideDown();

  $('html, body').animate({ scrollTop: formWrapper.offset().top - 150 });
}

// u.$ui.listDependent(
//   '#input-input-serial',
//   '#input-item-model',
//   {
//     text_field: 'text',
//     value_field: 'value',
//     ajax: {
//       url: u.route('repair_ajax_serials')
//     }
//   }
// );

function onSubmit(token) {
  $('.g-recaptcha').attr('disabled', true);
  document.getElementById('repair-form').submit();
}

window.onSubmit = onSubmit;
